import { render, staticRenderFns } from "./radio-option.vue?vue&type=template&id=58f2b320&scoped=true&"
import script from "./radio-option.vue?vue&type=script&lang=js&"
export * from "./radio-option.vue?vue&type=script&lang=js&"
import style0 from "./radio-option.vue?vue&type=style&index=0&id=58f2b320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f2b320",
  null
  
)

export default component.exports